import React, { useState } from "react";
import { Box, Button, Modal } from "@mui/material";
import { Typography } from "@material-ui/core";
import DB_Status from "../../model/enum/status.class";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ContactModal from "./ContactModal";
import Message from "../../model/message";
import CloseIcon from "@mui/icons-material/Close";
import useStyles from "./styles";
import { PrimaryColor } from "../../shared/styles/colors";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "40rem",
  bgcolor: "background.paper",
  border: "none",
  borderRadius: "8px",
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
  maxHeight: "90vh", // Restrict maximum height to 80% of the viewport height
  overflowY: "auto", // Enable vertical scrolling
  "@media (max-width: 640px)": {
    width: "80%",
  },
};

interface Props {
  contact: Message;
  resetList?: () => void;
}

const ContactDetailModal = ({ contact, resetList }: Props) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      <Button onClick={handleOpen}>
        <MoreVertIcon sx={{ color: PrimaryColor}}/>
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ overflowY: "auto" }}
      >
        <Box sx={style}>
          <div className={classes.headerDiv}>
            <Typography className={classes.title}>
              <div style={DB_Status.mapStatusDivColor(contact.Status?.name)}>
                <div
                  style={DB_Status.mapStatusRoundedColor(
                    contact.Status?.name,
                    false
                  )}
                ></div>
              </div>
            </Typography>
            <div className={classes.headerSubDiv}>
              <ContactModal contact={contact} resetList={resetList} />
              <Button onClick={handleClose} sx={{ color: "black" }}>
                <CloseIcon />
              </Button>
            </div>
          </div>
          <hr />
          <div className={classes.form}>
            <Typography className={classes.label}>Client</Typography>
            <Typography className={classes.inputDetail}>
              {contact.Client?.firstName} {contact.Client?.lastName}
            </Typography>
            <Typography className={classes.label}>Message</Typography>
            <textarea
              className={classes.textareaDetail}
              value={contact.text}
              disabled
            />
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default ContactDetailModal;
